"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _getValidProps = _interopRequireDefault(require("@helpscout/react-utils/dist/getValidProps"));

var _icons = _interopRequireDefault(require("./icons"));

var _styled = _interopRequireDefault(require("../styled"));

var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));

var _classNames = require("../../utilities/classNames");

var _component = require("../../utilities/component");

var _other = require("../../utilities/other");

var _IconCss = _interopRequireDefault(require("./styles/Icon.css.js"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Icon = function Icon(props) {
  var center = props.center,
      className = props.className,
      clickable = props.clickable,
      faint = props.faint,
      ignoreClick = props.ignoreClick,
      inline = props.inline,
      muted = props.muted,
      onClick = props.onClick,
      offsetLeft = props.offsetLeft,
      offsetRight = props.offsetRight,
      name = props.name,
      shade = props.shade,
      size = props.size,
      state = props.state,
      subtle = props.subtle,
      title = props.title,
      withCaret = props.withCaret,
      rest = _objectWithoutPropertiesLoose(props, ["center", "className", "clickable", "faint", "ignoreClick", "inline", "muted", "onClick", "offsetLeft", "offsetRight", "name", "shade", "size", "state", "subtle", "title", "withCaret"]);

  var componentClassName = (0, _classNames.classNames)('c-Icon', center && 'is-center', clickable && 'is-clickable', !clickable && ignoreClick && 'is-noInteract', faint && 'is-faint', inline && 'is-inline', name && "is-iconName-" + name, offsetLeft && 'is-offsetLeft', offsetRight && 'is-offsetRight', muted && 'is-muted', shade && "is-" + shade, state && "is-" + state, subtle && 'is-subtle', size && "is-" + size, withCaret && 'withCaret', className);
  var src = {
    __html: _icons.default[name]
  };
  var iconTitle = title || name;
  var caretMarkup = withCaret ? _react.default.createElement("span", {
    className: "c-Icon__icon is-caret",
    dangerouslySetInnerHTML: {
      __html: _icons.default['caret-down']
    },
    title: "Caret"
  }) : null;
  return _react.default.createElement("span", _extends({
    "aria-hidden": true
  }, (0, _getValidProps.default)(rest), {
    className: componentClassName,
    onClick: onClick,
    "data-icon-name": name
  }), _react.default.createElement("span", {
    className: "c-Icon__icon",
    dangerouslySetInnerHTML: src,
    title: iconTitle
  }), caretMarkup, _react.default.createElement(_VisuallyHidden.default, null, iconTitle));
};

Icon.defaultProps = {
  center: false,
  clickable: false,
  ignoreClick: true,
  muted: false,
  name: 'emoji',
  onClick: _other.noop,
  offsetLeft: false,
  offsetRight: false,
  size: '20',
  withCaret: false
};
(0, _component.namespaceComponent)(_utils.COMPONENT_KEY)(Icon);

var _default =
/*#__PURE__*/
(0, _styled.default)(Icon, {
  target: "e4gcyhb0"
})(_IconCss.default);

exports.default = _default;